import { CookiePolicyContent } from '@ophelos/ui/components/legal/cookie-policy-content';
import { ScrollArea } from '@ophelos/ui/components/scroll-area';
import { OphelosIcon } from '@/components/branding/ophelos-icon';
import { useCookieConsentSettings } from '@/contexts/CookieConsentContext';

export function CookiePolicyPage() {
  const cookieConsent = useCookieConsentSettings();

  return (
    <ScrollArea className="h-screen bg-background">
      <div className="mx-auto w-full max-w-3xl px-6 py-12 md:py-16">
        <OphelosIcon className="mb-10 size-9 text-foreground" />
        <CookiePolicyContent language="en" />
        {/* Reserve space for the fixed consent banner so the last text stays visible.
            A spacer element, not bottom padding: Radix's ScrollArea wraps the viewport
            child in a display:table box that drops trailing padding from the scroll height. */}
        {cookieConsent?.bannerOpen && <div aria-hidden className="h-52" />}
      </div>
    </ScrollArea>
  );
}
